














































































































import { defineComponent,	PropType } from '@vue/composition-api';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { GroupReportUser, REPORT_TYPE } from '@front-app/services/CommunityApi/CommunityReportsApi';
import { Size } from '@front-app/components/constants';
import {
	ALL_USER_ROLE_LABELS,
	UserRole,
	UserRoleApi,
	USER_ACCOUNT_STATUS_LABELS,
} from '@front-app/services/UserApi/UserModel';

export default defineComponent({
	components: {
		TrCheckbox,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		reportData: {
			type: Array as PropType<GroupReportUser[]>,
			required: true,
		},
		reportType: {
			type: String as PropType<REPORT_TYPE>,
			required: true,
		},
		selectedGroups: {
			type: Array as PropType<string[]>,
			default: () => [],
		},
		selectedUserIds: {
			type: Array as PropType<string[]>,
			required: true,
		},
		areAllUsersSelected: Boolean,
		isMemberManagementEnabled: Boolean,
	},
	setup(props, ctx) {
		const formatSpecialtiesOrInterests = (specialtiesOrInterests: string[]) => {
			if (specialtiesOrInterests.length === 1) {
				return specialtiesOrInterests[0];
			}
			if (specialtiesOrInterests.length > 1) {
				return specialtiesOrInterests.join(', ');
			}
			return '';
		};

		// Roles
		const GROUP_ROLE_LABELS: Record<UserRole, string> = {
			[UserRole.NONE]: 'none',
			[UserRole.DEPARTEE]: 'role_badge.departee',
			[UserRole.INVITEE]: 'role_badge.invitee',
			[UserRole.EXTERNAL_INVITEE]: 'role_badge.invitee',
			[UserRole.MEMBER]: props.reportType === REPORT_TYPE.GROUP_MEMBER_LISTING ? 'role_badge.member' : 'role_badge.registrant',
			[UserRole.MODERATOR]: 'role_badge.moderator',
			[UserRole.ADMINISTRATOR]: 'role_badge.admin',
		};
		const getGroupRoleLabel = (groupRole: UserRole) => ctx.root.$t(GROUP_ROLE_LABELS[groupRole]);
		function convertRoles(rolesFromApi: UserRoleApi[]) {
			// eslint-disable-next-line arrow-body-style
			const convertedRoles = rolesFromApi.map((roleFromApi) => {
				return ctx.root.$t(ALL_USER_ROLE_LABELS[roleFromApi]);
			});
			if (convertedRoles.length === 1) {
				return convertedRoles[0];
			}
			if (convertedRoles.length > 1) {
				return convertedRoles.join(', ');
			}
			return '';
		}

		return {
			formatSpecialtiesOrInterests,
			USER_ACCOUNT_STATUS_LABELS,
			// Roles
			getGroupRoleLabel,
			convertRoles,
			// Util
			ButtonPalettes,
			DropdownPosition,
			Size,
		};
	},
});
